import { Model } from '@vuex-orm/core'
import LtmHasRoomtypeHasRoomltm from '@models/helpers/LtmHasRoomtypeHasRoomltm'

export default class Ltm extends Model{
  static entity = 'ltms'
  static fields () {
    return {
      id: this.number(null),
      label: this.string(null).nullable(),
      ltmHasRoomtypeHasRoomltms: this.hasMany(LtmHasRoomtypeHasRoomltm, 'ltms_id')
    }
  }
}
  